import Submenu from '../Submenu'
import { ExternalLink, Link } from '../'
import { MenuItemProps } from '@/resources/types'

const MenuItem = ({ menuItem, onClick, isSubmenu = false }: MenuItemProps) => {
  if (menuItem.submenu) {
    return <Submenu menuItem={menuItem} onClick={onClick} />
  }

  if (menuItem.isExternalLink) {
    return <ExternalLink link={menuItem} />
  }

  return <Link link={menuItem} onClick={onClick} isSubmenuLink={isSubmenu} />
}

export default MenuItem
